import { AppStorageKey } from '../types';
import { Settings, Store } from '../wrappers';
import { Device } from '../utilities';
import { appStorage } from '../utilities/AppStorage';
import { AppEvent } from '../models';
import { CapacitorLan } from 'capacitor-lan';
class LocalNetworkService {
    terminal;
    canBecomeServer = false;
    serviceRunning = false;
    connectionStatus = undefined;
    constructor() { }
    async init() {
        if (Device.isWeb())
            return;
        const curTerminal = Store.get('terminal');
        this.terminal = curTerminal ? curTerminal.$toJson() : undefined;
        this.canBecomeServer = Device.isElectron() && this.terminal?.type === 'cashRegister';
        if (Device.isElectron()) {
            Settings.electron.on('lanEvent', (event, eventData) => this.onEventReceived(eventData));
            Settings.electron.on('lanConnectionUpdate', (event, eventData) => this.onConnectionUpdate(eventData));
        }
        else if (Device.isMobile()) {
            CapacitorLan.addListener('lanEvent', (eventData) => this.onEventReceived(eventData));
            CapacitorLan.addListener('lanConnectionUpdate', (eventData) => this.onConnectionUpdate(eventData));
        }
    }
    async reload() {
        if (Device.isWeb())
            return;
        if (this.serviceRunning) {
            await this.shutdown();
        }
        const curTerminal = Store.get('terminal');
        this.terminal = curTerminal ? curTerminal.$toJson() : undefined;
        if (!this.terminal)
            return;
        this.canBecomeServer = Device.isElectron() && this.terminal.type === 'cashRegister';
        const tenant = Store.get('tenant');
        if (!tenant?.venue)
            return;
        this.serviceRunning = true;
        if (Device.isElectron()) {
            await Settings.electron.invoke('lanReload', this.terminal, this.canBecomeServer, tenant.venue.hash);
        }
        else if (Device.isMobile()) {
            // iOS-only Bonjour fallback — the read and the extra field are
            // gated so the Android reload path stays byte-identical.
            const manualServerAddress = Device.isIOS()
                ? await appStorage.local().getItem(AppStorageKey.lanServerAddress) || undefined
                : undefined;
            await CapacitorLan.lanReload({ terminal: this.terminal, canBecomeServer: false, hash: tenant.venue.hash, ...(manualServerAddress ? { manualServerAddress } : {}) });
        }
    }
    async shutdown() {
        if (!this.terminal)
            return;
        if (Device.isElectron()) {
            await Settings.electron.invoke('lanShutdown');
        }
        else if (Device.isMobile()) {
            await CapacitorLan.lanShutdown();
        }
        this.serviceRunning = false;
    }
    onEventReceived(event) {
        if (!this.terminal)
            return;
        AppEvent.handle(event);
    }
    onConnectionUpdate(data) {
        if (!this.terminal)
            return;
        this.connectionStatus = data;
        Store.set('localConnection', data);
    }
    async getTerminals() {
        if (!this.terminal || !Device.isElectron())
            return [];
        const terminals = await Settings.electron.invoke('lanTerminals');
        return terminals;
    }
    async send(data) {
        if (!this.terminal)
            return { status: 'failed', error: 'not_supported' };
        data = JSON.parse(JSON.stringify(data));
        if (Device.isElectron()) {
            return Settings.electron.invoke('lanEvent', data);
        }
        else if (Device.isMobile()) {
            return CapacitorLan.lanSendEvent(data);
        }
        return { status: 'failed', error: 'not_supported' };
    }
}
export const localNetworkService = new LocalNetworkService();
export default localNetworkService;
//# sourceMappingURL=LocalNetworkService.js.map